import { Component, OnDestroy, OnInit } from '@angular/core';
import { HxAuthService, NotifierService } from 'hx-services';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [NgIf, RouterOutlet, TranslocoPipe]
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private notifierService: NotifierService,
    public auth: HxAuthService,
  ) {
  }

  ngOnInit() {
    this.notifierService.start();
  }

  ngOnDestroy() {
    this.notifierService.destroy();
  }
}
